export const auth = {
  ACCESS_TOKEN_KEY: 'access_token',
  ID_TOKEN_KEY: 'id_token',
  REFRESH_TOKEN_KEY: 'refresh_token',

  setTokens(accessToken, idToken, refreshToken) {
    localStorage.setItem(this.ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(this.ID_TOKEN_KEY, idToken);
    localStorage.setItem(this.REFRESH_TOKEN_KEY, refreshToken);

    const userInfo = this.decodeToken(idToken);
    localStorage.setItem('user_info', JSON.stringify(userInfo));
  },

  getIDToken() {
    return localStorage.getItem(this.ID_TOKEN_KEY);
  },

  getUserInfo() {
    const userInfo = localStorage.getItem('user_info');
    return userInfo ? JSON.parse(userInfo) : null;
  },

  isLoggedIn() {
    const token = this.getIDToken();
    return !!token && !this.isTokenExpired(token);
  },

  logout() {
    localStorage.removeItem(this.ACCESS_TOKEN_KEY);
    localStorage.removeItem(this.ID_TOKEN_KEY);
    localStorage.removeItem(this.REFRESH_TOKEN_KEY);
    localStorage.removeItem('user_info');
  },

  decodeToken(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((character) => `%${(`00${character.charCodeAt(0).toString(16)}`).slice(-2)}`)
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      return null;
    }
  },

  isTokenExpired(token) {
    try {
      const decoded = this.decodeToken(token);
      const currentTime = Date.now() / 1000;
      return decoded.exp < currentTime;
    } catch (error) {
      return true;
    }
  }
};
